export default "__VITE_ASSET__BYuvND55__"